package team.platforma.multiplatform_material_extension.calendar.utils

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember


@Composable
fun rememberCalendarBadges(): CalendarBadges {
    return remember { CalendarBadgesImpl() }
}

interface CalendarBadges {
    fun setBadgeMap(map: Map<String, Int>)
    fun addListener(listener: CalendarBadgesListener)
    fun removeListener(listener: CalendarBadgesListener)
}

interface CalendarBadgesListener {
    fun onSetBadgeMap(map: Map<String, Int>)
}

private class CalendarBadgesImpl() : CalendarBadges {

    private val listeners = mutableListOf<CalendarBadgesListener>()
    override fun setBadgeMap(map: Map<String, Int>) {
        listeners.forEach {
            it.onSetBadgeMap(map)
        }
    }

    override fun addListener(listener: CalendarBadgesListener) {
        listeners.add(listener)
    }

    override fun removeListener(listener: CalendarBadgesListener) {
        listeners.remove(listener)
    }

}

